interface AvatarGroupProps {
  assignees: Array<{ name: string; avatar: string }>;
  maxAvatars?: number;
}

export default function AvatarGroup({ assignees, maxAvatars = 4 }: AvatarGroupProps) {
  const displayedAssignees = assignees.slice(0, maxAvatars);

  return (
    <div className="flex items-start pl-0 pr-[5px] py-0">
      {displayedAssignees.map((assignee, index) => (
        <div
          key={index}
          className="h-[27px] w-[28px] mr-[-5px] rounded-full bg-gray-600 overflow-hidden flex-shrink-0"
          title={assignee.name}
        >
          {assignee.avatar ? (
            <img
              src={assignee.avatar}
              alt={assignee.name}
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="w-full h-full bg-gray-600 flex items-center justify-center text-white text-[10px] font-semibold">
              {assignee.name.charAt(0).toUpperCase()}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
